import {fetchProvider} from '../../utils/fetchProvider';

export const getCardDetails = ({languageCode: lang, paymentSessionId: id}) => {
    const url = `/${lang}/payments-integrations-webapp/props/getCybersourceCardDetails?paymentSessionId=${id}`;

    return fetchProvider(url);
};

export default {
    getCardDetails
};
